import { render, staticRenderFns } from "./DataFieldsReadonly.vue?vue&type=template&id=e25829da&scoped=true"
import script from "./DataFieldsReadonly.vue?vue&type=script&lang=ts"
export * from "./DataFieldsReadonly.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e25829da",
  null
  
)

export default component.exports